import "./styles.css";
import React from "react";
import "boxicons/css/boxicons.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MainRoutes from "./Routes/Routes";
import ReactGA from "react-ga4";
import { GoogleOAuthProvider } from "@react-oauth/google";

const CLIENT_ID = "616229363699-10mbra61uvaoim269ouaomqhqtjnfies.apps.googleusercontent.com";
  // OLD "616229363699-a7vjtcu64ng7678virfur1im5a3jd66d.apps.googleusercontent.com";
ReactGA.initialize("G-54TW4BGKM6");

function App() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <MainRoutes />
    </GoogleOAuthProvider>
  );
}

export default App;
